import { Box, Icon, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  dismissLoader,
  showLoader,
  updateScreenTitle,
} from "../../../LayoutContainers/AppLayout/redux/AppSlice";
import AppService from "../../../Configurations/Appservice";
import DataTable from "../../../Components/Table/DataTable";
import { useLocation, useNavigate } from "react-router-dom";

const tableInitialData = {
  columns: [
    { Header: "UID", accessor: "uid" },
    { Header: "First Name", accessor: "firstNameEn" },
    { Header: "Last Name", accessor: "lastNameEn" },
    { Header: "edit", accessor: "edit" },
  ],

  rows: [],
};

export function UidDirectory() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [tableData, setTableData] = useState(tableInitialData);

  useEffect(() => {
    dispatch(updateScreenTitle("UID Directory"));
    return () => dispatch(updateScreenTitle());
  }, []);

  const _navigateToEditScreen = (id) => {
    navigate("/USER_MGMT/new_uid", { state: { id } });
  };

  const _generateTableRows = (response) => {
    const rows = response.map((item) => ({
      ...item,
      //   createDateTime: moment.utc(item.createDateTime).local().format("YYYY-MM-DD"),
      edit: (
        <IconButton size="small" onClick={() => _navigateToEditScreen(item.id)}>
          <Icon>edit</Icon>
        </IconButton>
      ),
    }));

    let tableDataDuplicate = { ...tableData };
    tableDataDuplicate.rows = rows;
    setTableData(tableDataDuplicate);
  };

  useEffect(() => {
    dispatch(showLoader());

    AppService.get("v1/uid/directory")
      .then((response) => {
        _generateTableRows(response);
      })
      .catch(() => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {
        <DataTable
          table={tableData}
          showAddButton={true}
          addButtonOnClick={() => {
            navigate("/USER_MGMT/new_uid");
          }}
        />
      }
    </Box>
  );
}
